const STORAGE_KEY = 'meet-bizy-intro-shown-date';

function getUtcDateKey(): string {
	return new Date().toISOString().split('T')[0];
}

/** Persist the UTC calendar day the Meet Bizy intro modal was shown. */
export function markMeetBizyIntroShownToday(): void {
	try {
		localStorage.setItem(STORAGE_KEY, getUtcDateKey());
	} catch {
		// localStorage unavailable
	}
}

/** True when the Meet Bizy intro modal was shown today (UTC). */
export function wasMeetBizyIntroShownToday(): boolean {
	try {
		return localStorage.getItem(STORAGE_KEY) === getUtcDateKey();
	} catch {
		return false;
	}
}
